import React, { useEffect, useState } from 'react'

const ListCard = (props) => {
    const trackData = props.data
    const cardData = [
        {
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-barcode h-6 w-6"
                >
                    <path d="M3 5v14"></path>
                    <path d="M8 5v14"></path>
                    <path d="M12 5v14"></path>
                    <path d="M17 5v14"></path>
                    <path d="M21 5v14"></path>
                </svg>
            ),
            title: 'UPC',
            value: trackData?.upc,
        },
        {
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-shopping-cart h-6 w-6"
                >
                    <circle cx="8" cy="21" r="1"></circle>
                    <circle cx="19" cy="21" r="1"></circle>
                    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
                </svg>
            ),
            title: 'Total Sold',
            value: '3,888',
        },
        {
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-gavel h-6 w-6"
                >
                    <path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"></path>
                    <path d="m16 16 6-6"></path>
                    <path d="m8 8 6-6"></path>
                    <path d="m9 7 8 8"></path>
                    <path d="m21 11-8-8"></path>
                </svg>
            ),
            title: 'Open Auctions',
            value: trackData?.qty,
        },
    ]

    const styles = [{ color: '#e12114' }, { color: '#e12114' }, { color: '#16a249' }]

    return (
        <>
            {cardData.map((data, index) => (
                <div className="trackerCard" id={`index${index}`} key={index}>
                    <div className="svgBox" style={styles[index % styles.length]}>
                        {typeof data.svg === 'string' ? (
                            <div dangerouslySetInnerHTML={{ __html: data.svg }} />
                        ) : (
                            data.svg
                        )}
                    </div>
                    <div className="cardTags">
                        <p className="p">{data.title}</p>
                        <h3 className="val">{data.value}</h3>
                    </div>
                </div>
            ))}
        </>
    )
}

export default ListCard
